// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/forms/fields/Select/index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/forms/fields/Select/index.tsx");
  import.meta.hot.lastModified = "1740183864614.39";
}
// REMIX HMR END

import clsx from "clsx";
import React from "react";
import IconResolver from "~/components/IconResolver";
export const Select = React.forwardRef(_c = ({
  className,
  ...props
}, ref) => {
  return <div className="relative">
      <select ref={ref} className={clsx("appearance-none w-full", "bg-neutral-50 rounded-lg border border-primary-300 py-4 px-3 text-neutral-600", "disabled:cursor-not-allowed disabled:bg-neutral-50 disabled:text-neutral-300", "focus:border-primary-600 focus:outline-none focus:ring-primary-600 focus:ring-offset-primary-600", "active:border-primary-600 hover:border-primary-600", "placeholder:text-neutral-600 focus:placeholder:opacity-0", "aria-[invalid=true]:border-error-600 aria-[invalid=true]:ring-error-600 aria-[invalid=true]:ring-offset-error-600", className)} {...props} id={props.name} />
      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
        <IconResolver token="chevron-down" className="w-5 h-5 text-neutral-400" />
      </div>
    </div>;
});
_c2 = Select;
var _c, _c2;
$RefreshReg$(_c, "Select$React.forwardRef");
$RefreshReg$(_c2, "Select");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;